import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/homepage/Footer";

import HeroSection from "../components/kalon_method/HeroSection";
import PillarOverview from "../components/kalon_method/PillarOverview";

import EndurancePillar from "../components/kalon_method/EndurancePillar";
import StrengthPillar from "../components/kalon_method/StrengthPillar";
import SportsPillar from "../components/kalon_method/SportsPillar";
import NutritionPillar from "../components/kalon_method/NutritionPillar";

import PageConclusion from "../components/kalon_method/PageConclusion";

export default function KalonMethod() {
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (location.hash) {
        const element = document.querySelector(location.hash);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  }, [location]);

  const pillars = [
    { id: "endurance", title: "Pillar 1: Endurance" },
    { id: "strength", title: "Pillar 2: Strength & Aesthetics" },
    { id: "sports", title: "Pillar 3: Sports Performance" },
    { id: "nutrition", title: "Pillar 4: Nutrition & Longevity" }
  ];

  return (
    <div className="w-full py-16">
      <HeroSection />

      <PillarOverview pillars={pillars} />

      <EndurancePillar />
      <StrengthPillar />
      <SportsPillar />
      <NutritionPillar />

      <PageConclusion />

      <Footer />
    </div>
  );
}
